
import { ColumnRank, ColumnBib, ColumnName, ColumnWarnings, ColumnNoc, ColumnResult, ColumnPoints, ColumnRecords, ColumnQualification, ColumnExpander } from "components/common/TableColumns"
import { CellTieRule } from "../../race_track_sb/result/CellTieRule"

export function TableColumns(columnsAdded) {

    return (
        [
            ColumnRank({}),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnWarnings({}),
            ColumnResult({}),
            {
                accessor: 'extendedResults',
                id: 'TieRules',
                className: '',
                headerClassName: 'w-5',
                Cell: (props) => (
                    props.cell.row.original.extendedResults
                        ? <CellTieRule extendedResults={props.cell.row.original.extendedResults}></CellTieRule>
                        : ''
                )
            },
            ColumnRecords({}),
            ColumnQualification({}),
            ColumnExpander({ type: 'extendedResults', expandIrm: true })
        ]
    )
}


export default TableColumns
